import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Home from "./views/Home";
import Confirmation from "./views/Step10_Confirmation";

// Fallback page
import PageNotFound from "./views/components/PageNotFound";
import Invalid from "./views/components/Invalid";

import "./css/style.css";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="*" element={<PageNotFound />} /> {/*to close*/}
                <Route path="/" element={<PageNotFound />} /> {/*to close*/}
                <Route path="/:language/home/:code" element={<Home />} /> {/*to close*/}
                <Route path="/:language/home/nachtraeglicheanmeldung/:code" element={<Home />} /> {/*to close*/}
                <Route path="/:language/confirmation/:orderId" element={<Confirmation />} />
                <Route path="/:language/invalid" element={<Invalid />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
